import type { SxProps, Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

type StyleEntry =
  | SystemStyleObject<Theme>
  | ((theme: Theme) => SystemStyleObject<Theme>);

export const styles = {
  backdrop: (theme) => ({
    backgroundColor: theme.palette.backdrop.main,
  }),
  background: {
    '&.MuiDialog-paperWidthSm': {
      maxWidth: '100%',
    },
  },
  dialogContent: {
    padding: '24px',
  },
  dialogContentTop0: {
    padding: '24px',
    paddingTop: 0,
  },
  containerTitle: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: theme.spacing(4),
    borderBottom: '1px solid #D7D9E0',
    alignItems: 'center',
  }),
  containerTitle2: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    paddingBottom: '4px',
    borderBottom: '1px solid #D7D9E0',
    width: '100%',
  },
  actionsContainer: {
    margin: 'auto',
    marginTop: '16px',
    marginBottom: '16px',
  },
  closeButton: {
    position: 'absolute',
    right: '4px',
    top: 30,
    color: '#25282B',
  },
  closeIcon: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
  },
} satisfies Record<string, StyleEntry>;

// Helper para mergear estilos base con sx adicional
export const mergeStyles = (
  base: StyleEntry,
  extra?: SxProps<Theme>,
): SxProps<Theme> => {
  if (!extra) return base as SxProps<Theme>;
  if (typeof base === 'function') {
    return (theme: Theme) => ({
      ...(base as (theme: Theme) => SystemStyleObject<Theme>)(theme),
      ...(typeof extra === 'function'
        ? (extra as (theme: Theme) => SystemStyleObject<Theme>)(theme)
        : (extra as SystemStyleObject<Theme>)),
    });
  }
  return {
    ...(base as SystemStyleObject<Theme>),
    ...(typeof extra === 'function' ? {} : (extra as SystemStyleObject<Theme>)),
  } as SxProps<Theme>;
};
